import Authority from "../../../util/Authority"

type AuthorizationData = {
    userName: number
    roles: AvailableRoles[]
}

enum AvailableRoles {
    "FINANCIER" = "RolFinanciador",
    "PROVIDER" = "RolPrestador"
}

export const getRoleAndUser = ():AuthorizationData => {
    let authorizationData: AuthorizationData = { userName: Authority.getAuthorizedCompanyId() ?? 0, roles: [] }
    if(Authority.isProviderUser()){
        authorizationData.roles.push(AvailableRoles.PROVIDER)
    }else if(Authority.isFinancierUser()){
        authorizationData.roles.push(AvailableRoles.FINANCIER)
    }
    return authorizationData
}
